import { SubscriptionOfferStatus } from "@/gql/__generated__/graphql";
import { useMemo } from "react";
import {
  SubscriptionOffer,
  SubscriptionOfferTable
} from "../types/subscriptions.type";

export function useSubscriptionOfferTableData(
  subscriptionOffers: SubscriptionOffer[],
  filterNonPending: boolean
) {
  const data: SubscriptionOfferTable[] = useMemo(() => {
    return subscriptionOffers
      .filter(
        (subscriptionOffer) =>
          !filterNonPending ||
          subscriptionOffer.status === SubscriptionOfferStatus.Pending
      )
      .map(convertSubscriptionOfferToTableData);
  }, [filterNonPending, subscriptionOffers]);

  return data;
}

function convertSubscriptionOfferToTableData({
  id,
  email,
  app,
  status,
  name,
  createdAt,
  payment,
  expiresAt
}: SubscriptionOffer): SubscriptionOfferTable {
  return {
    id,
    email,
    appName: app.displayName,
    appImage: app.pictureUrl,
    status,
    reference: name,
    createdAt,
    monthlyPriceUSD: payment?.monthlyPriceUSD,
    trialDays: payment?.trialDays,
    expiresAt
  };
}
